export default "__VITE_ASSET__ByATjasx__"